import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
@Directive({
    selector: '[appTagCommander]',
    providers: [{ provide: Window, useValue: window }],
})
export class TagCommanderDirective {
    @Input() appTagCommander = '';
    constructor(
        private el: ElementRef,
        private window: Window,
        private logger: NGXLogger
    ) {}
    @HostListener('click') onClick() {
        this.logger.debug(
            'element : ',
            { el: this.el.nativeElement },
            'clicked with param : ',
            this.appTagCommander
        );
        if (this.window.tc_events_global) {
            const tagCommanderdataString =
                sessionStorage.getItem('tagCommander_data');
            if (tagCommanderdataString && tagCommanderdataString.length > 0) {
                const tagCommanderSessionData: any[] = JSON.parse(
                    tagCommanderdataString
                );
                if (tagCommanderSessionData) {
                    const tag = tagCommanderSessionData.find(
                        (e) => e.id === this.appTagCommander
                    );
                    const eventSent = tag ? tag.tag : {};
                    eventSent.elt = this.el.nativeElement;
                    this.logger.debug(
                        'Calling this.window.tc_events_global from TagCommanderDirective with : ',
                        {
                            eventSent,
                        }
                    );
                    this.window.tc_events_global(
                        this.el.nativeElement,
                        'event',
                        eventSent
                    );
                }
            }
        }
    }
}
